import { useState } from "react";
import { canvasPanelClassNames } from "../canvasTheme";
import type { EntityTypeStyle, SettingsPanelProps } from "../settingsPanelTypes";
import { EntityStyleFields } from "./EntityStyleFields";
import { SelectField } from "./SettingsPanelFields";

type EntitiesSettingsPageProps = Pick<
  SettingsPanelProps,
  "entityStyleOptions" | "entityTypeStyles" | "updateEntityTypeStyle"
>;

export function EntitiesSettingsPage({
  entityStyleOptions,
  entityTypeStyles,
  updateEntityTypeStyle,
}: EntitiesSettingsPageProps) {
  const [selectedKind, setSelectedKind] = useState(entityStyleOptions[0]?.kind ?? "");
  const selectedOption = entityStyleOptions.find((option) => option.kind === selectedKind) ?? entityStyleOptions[0];
  const selectedStyle = selectedOption ? entityTypeStyles[selectedOption.kind] : null;

  return (
    <div className={canvasPanelClassNames.section}>
      <h4 className={canvasPanelClassNames.sectionTitle}>Object Properties</h4>
      <SelectField
        label="Object"
        className="mt-2"
        value={selectedOption?.kind ?? ""}
        options={entityStyleOptions.map(({ kind, label }) => ({ value: kind, label }))}
        onChange={setSelectedKind}
      />
      <div className="mt-2 flex flex-col gap-3">
        {selectedOption && selectedStyle && (
          <div key={selectedOption.kind} className={canvasPanelClassNames.card}>
            <div className="mb-2 text-[12px] font-semibold text-[#1f2937]">{selectedOption.label}</div>
            <EntityStyleFields
              style={selectedStyle}
              updateStyle={(field, value) =>
                updateEntityTypeStyle(
                  selectedOption.kind,
                  field as keyof EntityTypeStyle,
                  value as EntityTypeStyle[keyof EntityTypeStyle],
                )
              }
            />
          </div>
        )}
      </div>
    </div>
  );
}
